// removed by extract-text-webpack-plugin
module.exports = {"tag_wrapper":"tag_wrapper","tag_wrapper_checked":"tag_wrapper_checked","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/CheckTag/style.scss
// module id = 1191
// module chunks = 0